"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const types_1 = require("./types");
const Checkbox_1 = __importDefault(require("./components/Checkbox"));
const Custom_1 = __importDefault(require("./components/Custom"));
const Datepicker_1 = __importDefault(require("./components/Datepicker"));
const ExpandableSection_1 = __importDefault(require("./components/ExpandableSection"));
const FieldArray_1 = __importDefault(require("./components/FieldArray"));
const Radio_1 = __importDefault(require("./components/Radio"));
const Review_1 = __importDefault(require("./components/Review"));
const Select_1 = __importDefault(require("./components/Select"));
const Subform_1 = __importDefault(require("./components/Subform"));
const Switch_1 = __importDefault(require("./components/Switch"));
const TreeView_1 = __importDefault(require("./components/TreeView"));
const Textarea_1 = __importDefault(require("./components/Textarea"));
const TextField_1 = __importDefault(require("./components/TextField"));
const TimePicker_1 = __importDefault(require("./components/TimePicker"));
const Wizard_1 = __importDefault(require("./components/Wizard"));
const basicComponentMapper = {
    [types_1.componentTypes.CHECKBOX]: Checkbox_1.default,
    [types_1.componentTypes.CUSTOM]: Custom_1.default,
    [types_1.componentTypes.DATE_PICKER]: Datepicker_1.default,
    [types_1.componentTypes.EXPANDABLE_SECTION]: ExpandableSection_1.default,
    [types_1.componentTypes.FIELD_ARRAY]: FieldArray_1.default,
    [types_1.componentTypes.RADIO]: Radio_1.default,
    [types_1.componentTypes.REVIEW]: Review_1.default,
    [types_1.componentTypes.SELECT]: Select_1.default,
    [types_1.componentTypes.SUB_FORM]: Subform_1.default,
    [types_1.componentTypes.SWITCH]: Switch_1.default,
    [types_1.componentTypes.TEXT_FIELD]: TextField_1.default,
    [types_1.componentTypes.TEXTAREA]: Textarea_1.default,
    [types_1.componentTypes.TIME_PICKER]: TimePicker_1.default,
    [types_1.componentTypes.TREE_VIEW]: TreeView_1.default,
    [types_1.componentTypes.WIZARD]: Wizard_1.default,
};
exports.default = basicComponentMapper;
//# sourceMappingURL=basicComponenntMapper.js.map